/**
 * Convert milliseconds in regular style time
 * @author Asa Baylus
 **/

export function convertMilliseconds(ms, p) {
  const pattern = p || 'hh:mm:ss'
  const arrayPattern = pattern.split(':')
  const clock = []
  const hours = Math.floor(ms / 3600000) // 1 Hour = 36000 Milliseconds
  const minutes = Math.floor((ms % 3600000) / 60000) // 1 Minutes = 60000 Milliseconds
  const seconds = Math.floor(((ms % 360000) % 60000) / 1000) // 1 Second = 1000 Milliseconds

  // build the clock result
  function createClock(unit) {
    // match the pattern to the corresponding variable
    if (pattern.match(unit)) {
      if (unit.match(/h/)) {
        addUnitToClock(hours, unit)
      }
      if (unit.match(/m/)) {
        addUnitToClock(minutes, unit)
      }
      if (unit.match(/s/)) {
        addUnitToClock(seconds, unit)
      }
    }
  }

  function addUnitToClock(val, unit) {
    if (val < 10 && unit.length === 2) {
      val = '0' + val
    }

    clock.push(val) // push the values into the clock array
  }

  // loop over the pattern building out the clock result
  for (var i = 0, j = arrayPattern.length; i < j; i++) {
    createClock(arrayPattern[i])
  }

  return {
    hours: hours,
    minutes: minutes,
    seconds: seconds,
    clock: clock.join(':')
  }
}



// WEBPACK FOOTER //
// ./src/utils/convertMilliseconds.js